// Navios (tracker das importações) — constantes da tela /navios.

/**
 * Cor por navio: paleta categórica validada (claro × escuro), em ordem FIXA.
 * A cor segue o navio (posição dele na lista completa por data de cadastro),
 * nunca o filtro — filtrar por tag não repinta ninguém. Os 3 primeiros slots
 * passam a checagem de daltonismo em todos os pares; do 4º em diante o nome
 * escrito ao lado do marcador é o que garante a identificação.
 */
export const VESSEL_COLORS = Object.freeze({
    light: ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'],
    dark: ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'],
});

/** Portos de referência do mapa (os mesmos do backend: seaRoute.js). */
export const REFERENCE_PORTS = Object.freeze([
    { key: 'ningbo', label: 'Ningbo', lat: 29.87, lon: 121.55 },
    { key: 'shekou', label: 'Shekou', lat: 22.48, lon: 113.91 },
    { key: 'singapura', label: 'Singapura', lat: 1.26, lon: 103.84 },
    { key: 'santos', label: 'Santos', lat: -23.98, lon: -46.3 },
]);

/** Enquadramento inicial do mapa: Ásia → Santos (lon oeste, lon leste, lat sul, lat norte). */
export const MAP_EXTENT = Object.freeze({ west: -58, east: 128, south: -42, north: 36 });

/** status (backend) → variante do Badge. */
export const STATUS_BADGE = Object.freeze({
    navegando: 'info',
    atracado: 'success',
    fundeado: 'default',
    parado: 'default',
    desconhecido: 'neutral',
    sem_sinal: 'warning',
    sem_posicao: 'neutral',
});

export const NAV_STATUS_OPTIONS = Object.freeze([
    { value: 'underway', label: 'Navegando' },
    { value: 'anchored', label: 'Fundeado' },
    { value: 'moored', label: 'Atracado' },
    { value: 'unknown', label: 'Desconhecido' },
]);

/** source da leitura (+ o site informado, quando veio pelo MCP ou à mão) → rótulo curto. */
export function SourceLabel(source, reportedSource = null) {
    if (!source) {
        return '—';
    }
    if (source.startsWith('provider:')) {
        return `AIS (${source.slice('provider:'.length)})`;
    }
    const channel = source === 'mcp' ? 'via Claude' : 'manual';
    return reportedSource ? `${reportedSource} · ${channel}` : channel;
}
